import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import { Box, Button, Container, Typography, useMediaQuery, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { SystemUpdateAltOutlined } from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { callPostApi } from '../API/ApiCallFunction';
import GradientLoader from '../CommanComponents/GradientLoader';

export default function Redeemed() {
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const navigate = useNavigate();
  const apiRef = useGridApiRef();
  const isMobile = useMediaQuery('(max-width:768px)');
  const [datar, setDatar] = useState([]);
  const [filterLimit, setFilterLimit] = useState(100);
  const [filterStatus, setFilterStatus] = useState('Redeemed');
  const [filterLotNo, setFilterLotNo] = useState('');
  const [locationftr, setlocationftr] = useState('');
  const [filterLoadedNo, setFilterLoadedNo] = useState('');
  
  //API
  const QRListApi= async (status, lotno, loadedNo, limit = filterLimit,locationflt = locationftr) => {
      try {
        setLoading(true);
        const storeid = user.store_info.store_id;
        const payload = { mod: "CASHI_QECODE_LIST", data_arr: { store_id:storeid, genLotNumber: lotno || '',loadingNumber:loadedNo || '',
            qrcodeStatus:status === "Redeemed" ? "2" : "", start: '0', limit:limit, },
         };
        const apiResult = await callPostApi("cashi-qrcode", payload);
        if (apiResult.status === "200" && Array.isArray(apiResult.data)) {
         const sorted = apiResult.data.slice().sort((a, b) => new Date(b.redeem_date) - new Date(a.redeem_date));
         const formattedData = sorted.filter((item) => item.redeem_status === "1" && item.cust_address.toLowerCase().includes(locationflt.toLowerCase())).map((item, index) => ({
          id: index + 1,
          lotno: item.gen_lot_number || "NA",
          qr: item.qrcode_number || "NA",
          customer_id: item.customer_id,
          expdate:item.redeem_date,
          cust_name:item.cust_name+"/"+item.cust_mobile,
          amount: item.amount || "0",
          loadedno: item.loading_number || "0",
          statuss: item.qrcode_status_name || "NA",
          address: item.cust_address || "NA",
          status:
            item.qrcode_status === "0"
              ? "Pending"
              : item.qrcode_status === "2"
              ? "Redeemed"
              : item.qrcode_status === "3"
              ? "Loaded"
              : "NA", 
        }));

        setDatar(formattedData);
         
        } else {
         setDatar([]);  
        }
      } catch (err) { 
      } finally {
        setLoading(false);
      }
    }; 
const setOpenD = (name,id)=>{
navigate('redeemedcusthistory', {
  state: {
    userName: name,
    custid: id
  }
});
}
  const clearFun = async () => {
    const newStatus = 'Redeemed';
    const newLotNo = '';
    const newLoadedNo = '';
    const lko = '';
    const newlimit = 100;
    setFilterStatus(newStatus);
    setFilterLotNo(newLotNo);
    setFilterLoadedNo(newLoadedNo);
    setFilterLimit(newlimit);
    setlocationftr(lko);
    await QRListApi(newStatus,newLoadedNo, newLoadedNo, newlimit,lko);
    }

  useEffect(() => {
    if (isMobile && apiRef.current) {
      apiRef.current.autosizeColumns({ includeHeaders: true });
    }
    QRListApi(Redeemed, '','', filterLimit);
  }, [isMobile]);
 
 
 const columns = [
  { field: 'id', headerName: 'Sr no.', flex: isMobile ? undefined : 0.5},
  { field: 'qr', headerName: 'QR',  flex: isMobile ? undefined : 1,},
  { field: 'amount', headerName: 'Amount', flex: isMobile ? undefined : 0.6 },
  { field: 'cust_name', headerName: 'Customer Name/Mobile', flex: isMobile ? undefined : 1},
  { field: 'address', headerName: 'Address', flex: isMobile ? undefined : 0.9},
  { field: 'lotno', headerName: 'Lot Number', flex: isMobile ? undefined : 1 },
  { field: 'loadedno', headerName: 'Loading Number', flex: isMobile ? undefined : 1 },
  { field: 'expdate', headerName: 'Date', flex: isMobile ? undefined : 1 },
     { field: "Action", headername: "Action", flex: isMobile ? undefined : 1, minWidth: 140,
     renderCell: (params) => ( <Button className='btn btn-success' onClick={() => {  setOpenD(params.row.cust_name,params.row.customer_id);}}>  History</Button> ),},
  
 ]

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
        <Button
          variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }}
          onClick={() => navigate("/dashboardPlus")} >  Back </Button>
      </Box>

      <Typography   variant="h6" gutterBottom  sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',
          p: 1,  color: '#ffffff', borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center'}} > 
          <SystemUpdateAltOutlined sx={{mx:1, fontSize:'22px'}}/> Redeemed QR List
      </Typography>

      <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>
        <TextField select label="Filter Status" value={filterStatus}
          onChange={e => {  setFilterStatus(e.target.value); }} sx={{ minWidth: 140 }} >
            <MenuItem value="Redeemed">Redeemed</MenuItem>
        </TextField>
        <TextField  type='text' label="Lot Number" value={filterLotNo}  onChange={e => setFilterLotNo(e.target.value)}
          sx={{ minWidth: 100,maxWidth:120 }} >
        </TextField>
        <TextField type='text' label="Loading Number" value={filterLoadedNo} onChange={e => setFilterLoadedNo(e.target.value)}
          sx={{ minWidth: 100, maxWidth:120 }} />
        <TextField select label="Limit" value={filterLimit} onChange={e => { setFilterLimit(e.target.value); }} sx={{ minWidth: 140 }} >        
          <MenuItem value={100}>100</MenuItem>
          <MenuItem value={300}>300</MenuItem>
          <MenuItem value={500}>500</MenuItem>
          <MenuItem value={2000}>All</MenuItem>
        </TextField>
 <TextField  type='text' label="Location" value={locationftr }  onChange={e => setlocationftr(e.target.value)}
          sx={{ minWidth: 100,maxWidth:120 }} >
        </TextField>
         <Button variant="outlined" color="primary" sx={{ height: 56 }}
          onClick={() => { QRListApi(filterStatus, filterLotNo, filterLoadedNo, filterLimit); }} > Apply Filter </Button>
         <Button variant="outlined" color="error" sx={{ height: 56 }}
          onClick={() => { clearFun() }} > Clear Filter </Button>
      </Box>

      {/* DataGrid */}
      <Box sx={{ height: 'auto',  width: '100%', mb: 4 }}>
        <DataGrid
          rows={datar} showToolbar  columns={columns} disableRowSelectionOnClick getRowHeight={() => "auto"}
           initialState={{ pagination: { paginationModel: { pageSize: 10 },}, }} pageSizeOptions={[10, 25, 50]}
          sx={{
             '& .MuiDataGrid-cell': {
               whiteSpace: 'normal',     // Allow wrapping
               lineHeight:'20px',
               wordBreak: 'break-word', 
      
               display: 'flex',
              alignItems: 'center', // Vertically center content
              gap: '4px'},
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontSize: 14,
              fontWeight: '600',
               whiteSpace: 'normal',
              wordBreak: 'break-word'
            },
          }}
         />
      </Box>
      {loading && <GradientLoader text="Loading" />} 
    </Container>
  );
}
